/**
 * @generated SignedSource<<31c0e1d6c5cbf339194c3cddc3705c8f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type PaymentSource = "CASH" | "NONCE" | "RAINCHECK" | "SQUARE_CARD_ON_FILE" | "SQUARE_GIFT_CARD" | "SQUARE_HOUSE_ACCOUNT";
import { FragmentRefs } from "relay-runtime";
export type PatronCheckoutLoyaltyRewardsBookingProjection_order$data = {
  readonly bookings: ReadonlyArray<{
    readonly id: string;
    readonly projectedCreditApplications: ReadonlyArray<{
      readonly amount: number;
      readonly paymentSource: PaymentSource;
      readonly raincheck: {
        readonly id: string;
      } | null | undefined;
      readonly squareGiftCard: {
        readonly ganLastFour: string | null | undefined;
        readonly id: string;
      };
    }>;
    readonly totalDueAfterCredits: number | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "PatronCheckoutLoyaltyRewardsBookingProjection_order";
};
export type PatronCheckoutLoyaltyRewardsBookingProjection_order$key = {
  readonly " $data"?: PatronCheckoutLoyaltyRewardsBookingProjection_order$data;
  readonly " $fragmentSpreads": FragmentRefs<"PatronCheckoutLoyaltyRewardsBookingProjection_order">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PatronCheckoutLoyaltyRewardsBookingProjection_order",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "bookings",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalDueAfterCredits",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectedCreditApplication",
          "kind": "LinkedField",
          "name": "projectedCreditApplications",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "amount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "paymentSource",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "SquareGiftCard",
              "kind": "LinkedField",
              "name": "squareGiftCard",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "ganLastFour",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Raincheck",
              "kind": "LinkedField",
              "name": "raincheck",
              "plural": false,
              "selections": [
                (v0/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Order",
  "abstractKey": null
};
})();

(node as any).hash = "db8de8f6be53b76614e376c7112b20ad";

export default node;
